import type {AppDispatch, RootState} from '@src/client/index';
import {setPage, setStatusFilter, fetchArchiveRequests} from './archiveSlice';

interface ArchiveSsrFetchStore {
    dispatch: AppDispatch;
    getState: () => RootState;
}

interface ArchiveSsrFetchParams {
    page?: string;
    status?: string;
}

export default function ssrFetch({
    store, params, headers, timeout
}: {
    store: ArchiveSsrFetchStore;
    params?: ArchiveSsrFetchParams;
    headers?: Record<string, string>;
    timeout?: number;
}) {
    const page = params?.page ? Number(params.page) : NaN;
    if (!Number.isNaN(page)) {
        store.dispatch(setPage(page));
    }
    if (params?.status) {
        store.dispatch(setStatusFilter(params.status));
    }

    return store.dispatch(fetchArchiveRequests({headers, timeout}));
}
